import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class AiAgentsAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'AI_AGENT_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'AI_AGENT_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EDIT //
  editSuccess() {
    const message = {
      body: 'AI_AGENT_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editError() {
    const message = {
      body: 'AI_AGENT_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess() {
    const message = {
      body: 'AI_AGENT_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'AI_AGENT_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.ai-agents')
  .service('aiAgentsAlertsService', AiAgentsAlertsService);
